/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CrownShape } from './CrownShape';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
// @Shape('Shape3D.Polygon')
export class Shape3DPolygon extends CrownShape {
    // this implementation doesn't make much sense in combination with the 3DViewer
    // this is the comment from the manifest:
    // Create a 2D closed polygon embedded in 3D space. If the points are not in a plane, the points are projected onto the best fitting plane. At least three points are required.
    //
    // ?? and now?
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometry = Solids.createPolygonUnsafe(shape.points);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide });
        this.addOutline(geometry, decoration);
    }
    format() {
        return undefined;
    }
}
//# sourceMappingURL=Shape3DPolygon.js.map